const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7C00"
    },
    d: "M512,256c0,58.932-19.916,113.215-53.384,156.484c-18.704,24.189-41.66,44.941-67.73,61.137  C351.713,497.957,305.507,512,256,512s-95.713-14.043-134.886-38.379c-11.222-6.969-21.87-14.785-31.838-23.353  C34.617,403.32,0,333.699,0,256C0,114.615,114.615,0,256,0S512,114.615,512,256z",
    "data-original": "#BEBEBE",
    className: "active-path",
    "data-old_color": "#FF8400"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D4D4D4"
    },
    d: "M465.011,388.086l-6.395,24.398c-18.704,24.189-41.66,44.941-67.73,61.137H121.114  c-11.222-6.969-21.87-14.785-31.838-23.353l29.445-112.358l-53.52,19.801l17.951-65.484l52.642-19.498l61.827-235.875h136.505  L286.97,216.785l67.396-24.952l-17.951,65.494l-66.529,24.628l-27.815,106.13L465.011,388.086L465.011,388.086z",
    "data-original": "#F0EFEB",
    className: "",
    "data-old_color": "#D6D4CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/LTC.390dbeeed8baed3d20ee870fcae05f89.svg";
export { ForwardRef as ReactComponent };